import { imageUrl } from '@helpers/image';
import React from 'react';
import S from './ImageWithCredit.styles';
const ImageWithCredit = ({ image, imageMode = undefined, imageProps = {}, sizes, srcSet, }) => {
    return (React.createElement(S.Container, { "data-image-mode": imageMode },
        React.createElement(S.Image, { alt: image?.altText, draggable: false, loading: "eager", role: "presentation", src: imageUrl(image, imageProps), sizes: sizes, srcSet: srcSet }),
        image.credit && React.createElement(S.ImageCredit, null, image.credit)));
};
export default ImageWithCredit;
